'use strict';

export default function f($rootScope, $q, $http, $location, payModal, utils, userModel, paymentTypes, payments, modal, analytics, fastPayModal, currencyModel) {
  'ngInject';

  const analyticsCategoryName = 'Booking';
  const analyticsEventName = 'MadePayment';

  return {
    showPaymentWindow(paymentData) {
      paymentData.meta.PAYMENT_TYPE = paymentTypes.booking;

      var fastPaymentAvailable = userModel.item.membership.activeContract;

      if (fastPaymentAvailable) {
        return fastPayModal.open(paymentData, this);
      } else {
        return payModal.open(paymentData, this);
      }
    },

    processPayment(paymentData) {
      delete paymentData.meta;

      return this.sendPaymentData(paymentData);
    },

    sendPaymentData(paymentData) {
      //  adyen-encrypted-data: "enccypreData",
      //   {
      //   bookingId: this.booking.bookingId,
      //   hours: this.bookingHours,
      //   fullPrice: this.hourlyRate * this.bookingHours,
      //   currency: this.currency,
      //   isForFuturePayments: 1/0
      // };
      var url = utils.getApiUrlV2('/bookings/' + userModel.item.id + '/recurring_payment');
      return new $q((resolve, reject) => {
        $http.post(url, paymentData)
          .then((response) => resolve(response))
          .catch(reject);
      });
    },

    sendFastPaymentData(paymentData) {
      delete paymentData.meta;
      //   {
      //   bookingId: this.booking.bookingId,
      //   hours: this.bookingHours,
      //   fullPrice: this.hourlyRate * this.bookingHours,
      //   currency: this.currency
      // };
      var url = utils.getApiUrlV2('/bookings/' + userModel.item.id + '/contract_payment');
      return new $q((resolve, reject) => {
        $http.post(url, paymentData)
          .then((response) => resolve(response))
          .catch(reject);
      });
    },

    // deprecated - rewrite
    showCompletedPaymentWindow: function (authResult, booking, location) {
      var paymentStatus = payments.getPaymentStatus(authResult);
      var scope = $rootScope.$new();

      if (['successful', 'pending'].indexOf(paymentStatus) > -1) {
        analytics.track(analyticsEventName, {
          category: analyticsCategoryName,
          value: booking.fullPrice,
          currency: currencyModel.getValue(),
        });
      }

      scope.booking = booking;
      scope.location = location;
      scope.status = paymentStatus;
      scope.retry = () => {
        // TODO: Fix me
        this.showPaymentWindow(booking.bookingId, '/conversations/' + booking.guideId);
      };

      return modal.open({
        template: '<completed-payment status="{{ status }}" booking="booking" location="location" done="close()" retry="retry()"></completed-payment>',
        scope: scope,
        closeOnStateChange: true
      }).result;
    },

    getReloadURL(authCode) {
      var reloadURL = `${$location.path()}?authResult=${authCode}`;
      return reloadURL;
    },
  };
}



// WEBPACK FOOTER //
// ./app/src/services/payments_booking.service.js